export interface ContatoDestaqueData {
  '@type'?: string;
  titulo?: string;
  texto?: string;
  telefone?: string;
  telefoneRotulo?: string;
  botaoRotulo?: string;
}

export const CONTATO_DESTAQUE_TITULO = 'Não encontrou o que procura?';
export const CONTATO_DESTAQUE_TELEFONE_ROTULO = 'Ligação gratuita';
export const CONTATO_DESTAQUE_BOTAO_ROTULO = 'Ligar agora';
export const CONTATO_DESTAQUE_COPIADO = 'Número 0800 copiado!';
export const CONTATO_DESTAQUE_ERRO_COPIA = 'Não foi possível copiar o número.';
export const CONTATO_DESTAQUE_DICA_COPIA = 'copia o número';
export const MIDIA_COPIA_NUMERO = '(hover: hover) and (pointer: fine)';

export const toDiscagemHref = (telefone?: string): string | undefined => {
  const digitos = (telefone ?? '').replace(/\D/g, '');
  return digitos ? `tel:${digitos}` : undefined;
};

export const nomeDoBotao = (
  rotulo: string,
  telefone: string,
  telefoneRotulo?: string,
  copia = false,
): string =>
  [
    `${rotulo}: ${telefone}`,
    telefoneRotulo?.trim(),
    copia && CONTATO_DESTAQUE_DICA_COPIA,
  ]
    .filter(Boolean)
    .join(', ');
